import { render, staticRenderFns } from "./invoice-options-send-to-orm.vue?vue&type=template&id=4d47f484&scoped=true"
import script from "./invoice-options-send-to-orm.vue?vue&type=script&lang=js"
export * from "./invoice-options-send-to-orm.vue?vue&type=script&lang=js"
import style0 from "./invoice-options-send-to-orm.vue?vue&type=style&index=0&id=4d47f484&prod&scoped=true&lang=css"
import style1 from "./invoice-options-send-to-orm.vue?vue&type=style&index=1&id=4d47f484&prod&lang=css"
import style2 from "./invoice-options-send-to-orm.vue?vue&type=style&index=2&id=4d47f484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d47f484",
  null
  
)

export default component.exports